import React, { useState } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { Gear, GearFill, ClipboardData, ClipboardDataFill, Collection, CollectionFill, JournalBookmark, JournalBookmarkFill } from "react-bootstrap-icons";
import { Button } from 'react-bootstrap';
import "./styles.css";

const Menu = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    const navItems = [
        {
            id: 'notches',
            label: 'Notches',
            route: '/notches',
            icon: <JournalBookmark size={24} />,
            iconActive: <JournalBookmarkFill size={24} />
        },
        {
            id: 'collections',
            label: 'Collections',
            route: '/collections',
            icon: <Collection size={24} />,
            iconActive: <CollectionFill size={24} />
        },
        {
            id: 'statistics',
            label: 'Statistics',
            route: '/statistics',
            icon: <ClipboardData size={24} />,
            iconActive: <ClipboardDataFill size={24} />
        },
        {
            id: 'settings',
            label: 'Settings',
            route: '/settings',
            icon: <Gear size={24} />,
            iconActive: <GearFill size={24} />
        }
        // {
        //     id: 'sandbox',
        //     label: 'Sandbox',
        //     route: '/sandbox',
        //     icon: <Gear size={24} />,
        //     iconActive: <GearFill size={24} />
        // }
    ];

    const currentRoute = location.pathname;

    const handleNavigation = (route) => {
        navigate(route);
    };

    return (
        <div className="fixed-bottom bottom-menu">
            <div className="d-flex justify-content-center align-items-center w-100">
                {navItems.map(item => {
                    const isActive = currentRoute === item.route;

                    return (
                        <Button
                            key={item.id}
                            variant="link"
                            className={`nav-btn ${isActive ? 'active' : 'nav-not-active'} ${isMobile ? 'flex-fill' : ''}`}
                            onClick={() => handleNavigation(item.route)}
                        >
                            <div className="icon position-relative">
                                {isActive ? item.iconActive : item.icon}
                                {item.badge && (
                                    <span className="badge bg-warning themed-text ms-1 small position-absolute" style={{ fontSize: '0.6rem' }}>
                                        {item.badge.toUpperCase()}
                                    </span>
                                )}
                            </div>
                            <div className="label" style={{ fontSize: '0.8rem' }}>
                                {item.label}
                            </div>
                        </Button>
                    );
                })}
            </div>
        </div>
    );
};

export default Menu;
